import React from "react"
import { graphql } from "gatsby"

export const query = graphql`
  fragment ArticleContentTextFields on DatoCmsArticleBlockText {
    id
    model {
      apiKey
    }
    textNode {
      childMarkdownRemark {
        html
      }
    }
    heading
  }
`

import { ArticleContentTextFieldsFragment } from "../../../../graphql-types"

const ArticleBlockText: React.FC<ArticleContentTextFieldsFragment> = props => {
  return (
    <div className="c-article-block-text">
      {props.heading && (
        <h2 className="c-article-block-text__heading">{props.heading}</h2>
      )}
      {props.textNode && props.textNode.childMarkdownRemark && (
        <div
          className="c-article-block-text__text"
          dangerouslySetInnerHTML={{
            __html: props.textNode.childMarkdownRemark.html,
          }}
        />
      )}
    </div>
  )
}

export default ArticleBlockText
